<template>
    <highcharts :options="options"/>
</template>

<script>
    /* eslint-disable */

    /**
     * Orders received per five minutes over the last hour.
     *
     * Its own component rather than Dashboard/LineChart.vue, whose tooltip is hardcoded
     * to "Rs." — correct for sales, wrong for a count of orders.
     *
     * highcharts-vue is registered globally in main.js, so <highcharts> needs no import.
     */
    export default {
        name: "LiveArrivalsChart",
        props: {
            buckets: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            categories() {
                // 55m ago ... now, in five-minute steps.
                return this.buckets.map((value, index) => {
                    const minutesAgo = (this.buckets.length - 1 - index) * 5;
                    return minutesAgo === 0 ? 'now' : minutesAgo + 'm';
                });
            },
            options() {
                return {
                    chart: {
                        type: 'areaspline',
                        height: 190,
                        spacingTop: 10,
                        backgroundColor: 'transparent'
                    },
                    title: {text: null},
                    credits: {enabled: false},
                    legend: {enabled: false},
                    xAxis: {
                        categories: this.categories,
                        tickLength: 0,
                        lineColor: '#e7eaec',
                        labels: {style: {color: '#9a9da0', fontSize: '10px'}}
                    },
                    yAxis: {
                        title: {text: null},
                        allowDecimals: false,
                        min: 0,
                        gridLineColor: '#f1f3f4',
                        labels: {style: {color: '#9a9da0', fontSize: '10px'}}
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:11px">{point.key} ago</span><br/>',
                        pointFormat: '<b>{point.y}</b> order(s)'
                    },
                    plotOptions: {
                        areaspline: {
                            lineWidth: 2,
                            marker: {enabled: false, symbol: 'circle', radius: 3},
                            fillOpacity: 0.18
                        }
                    },
                    series: [{
                        name: 'Orders',
                        color: '#1ab394',
                        data: this.buckets
                    }]
                };
            }
        }
    }
</script>
